<template>
    <div>
        <div class="row">
            <div class="col-lg-12">
                <a href="/admin/configuracoes/partnership/create" class="btn btn-md m-l-10 btn-primary">Novo Parceiro</a>
            </div>
        </div>

        <div style="overflow-x:auto; margin-top: 20px">
            <table id="partnership_table" class="table table-responsive table-hover table-mail partnershipTable">
                <thead>
                <tr>
                    <th>Parceiro</th>
                    <th>Contato</th>
                    <th>Celular</th>
                    <th>Email</th>
                    <th>Cupom</th>
                    <th>Cupom Para</th>
                    <th>Cashback (%)</th>
                    <th>Usuários</th>
                    <th>Cortesias</th>
                    <th>Status</th>
                    <th>Ações</th>
                </tr>
                </thead>

            <tbody>
                <tr v-for="partnership in partnerships">
                    <td>
                        {{ partnership.name }}
                    </td>
                    
                    <td>{{ partnership.contact_name }}</td>
                    <td>{{ partnership.contact_mobile_phone}}</td>
                    <td>{{ partnership.email }}</td>
                    <td>{{ partnership.coupon_code }}</td>
                    <td>
                        <span v-if="partnership.coupon_for === 'expert'">Perito</span>
                        <span v-else-if="partnership.coupon_for === 'contractor'">Contratante</span>
                        <span v-else-if="partnership.coupon_for === 'all'">Todos</span>
                        <span v-else>-</span>
                    </td>
                    <td>
                        <span v-if="partnership.coupon_cashback_percentage">
                            {{ partnership.coupon_cashback_percentage }}%
                        </span>
                        <span v-else>-</span>
                    </td>
                    <td>{{ partnership.total }}</td>
                    <td>{{ partnership.total_courtesy }}</td>
                    <template v-if="partnership.active">
                        <td>Ativo</td>
                    </template>
                    <template v-else>
                        <td>Invativo</td>
                    </template>
                    <td>
                        <button 
                            type="button" 
                            class="btn btn-sm btn-primary" 
                            @click="editPartnership(partnership.id)"
                            title="Editar parceiro"
                            style="margin-right: 5px;"
                        >
                            <i class="fa fa-edit"></i>
                        </button>
                        <button 
                            type="button" 
                            class="btn btn-sm btn-info" 
                            @click="viewPartnershipUsers(partnership.id)"
                            title="Ver usuários do parceiro"
                        >
                            <i class="fa fa-users"></i>
                        </button>
                    </td>
                </tr>
            </tbody>

            </table>
        </div>
    </div>
</template>

<script>
    import moment from 'moment';

    export default {
        props:{
            partnerships:{
                type:Array
            }
        },
        data(){
            return {
                dataTable:null,
            }
        },
        mounted(){
        },
        methods: {
            editPartnership(partnershipId) {
                // Redireciona para a página de edição do parceiro
                window.location.href = `/admin/configuracoes/partnership/${partnershipId}/edit`;
            },
            viewPartnershipUsers(partnershipId) {
                // Redireciona para a página de usuários do parceiro
                window.location.href = `/admin/configuracoes/partnership/${partnershipId}/users`;
            }
        }
    }
</script>